export * from './icon-pixel.component';
